"use client";

import Link from "next/link";
import Button from "./ui/Button";
import Image from "next/image";
import { ChevronRight, MapPin, Send } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative z-10 flex snap-end flex-col items-center rounded-t-3xl bg-[#333] px-6 pt-8 pb-2 text-white lg:px-6 [&_a]:text-white [&_a]:hover:underline">
      <div className="flex w-full max-w-300 flex-col justify-between gap-12 border-b border-white pb-4 md:flex-row lg:gap-20">
        <div className="md:w-1/3 lg:w-1/4">
          <h4 className="mb-3.5 font-black">More</h4>
          <ul className="flex flex-col gap-2.5 text-base">
            <li>
              <Link
                href={"/talent-stories"}
                className="flex max-w-max items-center gap-2"
              >
                <ChevronRight size={20} /> Talent Stories
              </Link>
            </li>
            <li>
              <Link
                href={"/client-stories"}
                className="flex max-w-max items-center gap-2"
              >
                <ChevronRight size={20} /> Client Stories
              </Link>
            </li>
            <li>
              <Link
                href={"/partner-with-us"}
                className="flex max-w-max items-center gap-2"
              >
                <ChevronRight size={20} /> Partner With Us
              </Link>
            </li>
            <li>
              <Link
                href={"/association-statutes"}
                className="flex max-w-max items-center gap-2"
              >
                <ChevronRight size={20} /> Association Statutes
              </Link>
            </li>
            <li>
              <Link
                href={"/faqs"}
                className="flex max-w-max items-center gap-2"
              >
                <ChevronRight size={20} /> FAQ
              </Link>
            </li>
          </ul>
        </div>
        <div className="md:w-1/3 lg:w-1/5">
          <h4 className="mb-3.5 font-black">Contact</h4>
          <ul className="flex flex-col gap-2.5 text-base leading-relaxed">
            <li className="flex items-start gap-2">
              <MapPin size={16} className="h-lh" />
              <Link
                href="https://maps.app.goo.gl/3oZCMrkuZex7ZXfe8"
                target="_blank"
              >
                Spitalgasse 28
                <br />
                3011 Bern
                <br />
                Switzerland
              </Link>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={16} className="h-lh" />
              <Link
                href="https://maps.app.goo.gl/VYW6DB4NythcqFfR9"
                target="_blank"
              >
                3 street 208
                <br />
                Maadi, Cairo
                <br />
                Egypt
              </Link>
            </li>
            <li className="flex items-center gap-2">
              <Send size={16} />
              <Link href="mailto:hello@remotecoders.org">
                hello@remotecoders.org
              </Link>
            </li>
          </ul>
        </div>
        <div className="md:w-1/3 lg:w-1/4">
          <h4 className="mb-4 font-black">Donate</h4>
          <p className="!text-base leading-relaxed">
            Your contribution helps us create lasting opportunities in tech for
            those who need it most.
          </p>
          <Link
            href={
              "https://donate.raisenow.io/pxgxx?analytics.channel=button&lng=en"
            }
            target="_blank"
            className="hover:!no-underline"
          >
            <Button color="primary" className="mt-4 cursor-pointer px-6">
              <Image
                width={32}
                height={32}
                src="/icons/donate.svg"
                alt="donate icon"
                className="mr-2 inline"
              />
              Donate
            </Button>
          </Link>
        </div>
      </div>
      <div className="flex w-full max-w-300 flex-col items-center justify-between gap-4 pt-2 md:flex-row lg:gap-6">
        <ul className="flex flex-wrap items-center justify-center gap-y-2 divide-x divide-white text-sm">
          <li className="pr-2">2025 © Remotecoders</li>
          <li className="px-2">
            <Link href={"/terms-and-conditions"}>Terms and conditions</Link>
          </li>
          <li className="px-2">
            <Link href={"/privacy-policy"}>Privacy policy</Link>
          </li>
        </ul>
        <div className="flex gap-4 [&>*]:hover:scale-110">
          <Link href={"https://x.com/RemotecodersME"} target="_blank">
            <Image width={20} height={20} src="/icons/x.svg" alt="x icon" />
          </Link>
          <Link
            href={"https://www.linkedin.com/company/remotecoders-mena/"}
            target="_blank"
          >
            <Image
              width={20}
              height={20}
              src="/icons/linkedin.svg"
              alt="linkedin icon"
            />
          </Link>
          <Link
            href={"https://www.instagram.com/remotecoders.mena"}
            target="_blank"
          >
            <Image
              width={20}
              height={20}
              src="/icons/instagram.svg"
              alt="instagram icon"
            />
          </Link>
          <Link
            href={"https://www.facebook.com/remotecoders.mena/"}
            target="_blank"
          >
            <Image
              width={20}
              height={20}
              src="/icons/facebook.svg"
              alt="facebook icon"
            />
          </Link>
        </div>
      </div>
    </footer>
  );
}
